// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relationships-member-list{overflow-y:scroll;max-height:250px}", ""]);
// Exports
module.exports = exports;
